import { action, extendObservable } from 'mobx';

class HeaderState {
  constructor(railsProps) {
    extendObservable(this, {
      drawerOpen: false,
      memberSignedIn: railsProps.member_signed_in,
      get mvcHomePath() {
        if (this.memberSignedIn === true) {
          return '/members/submit-a-grade';
        } else {
          return '/mvc-awards';
        }
      }
    });
  }

  @action.bound
  closeDrawer() {
    this.drawerOpen = false;
  }

  @action.bound
  openDrawer() {
    this.drawerOpen = true;
  }
}

export default HeaderState;
